import { Tags } from 'rbh-merchant-core';
import { RootState } from '../../../../redux/root-reducer';
import { FOOD_MENU_ACTION_TYPE, FoodMenuActions } from './foodmenu-type';

export enum FOOD_MENU_KEY {
  FOOD_MENU = 'FOOD_MENU',
  FOOD_QC_KEYWORD = 'FOOD_QC_KEYWORD',
  IS_POS_ACTIONED = 'IS_POS_ACTIONED',
  TAGS_LIST = 'TAGS_LIST',
}

export type FoodMenuState = {
  [FOOD_MENU_KEY.FOOD_MENU]?: []
  [FOOD_MENU_KEY.FOOD_QC_KEYWORD]?: []
  [FOOD_MENU_KEY.IS_POS_ACTIONED]?: boolean
  [FOOD_MENU_KEY.TAGS_LIST]?: Tags[]
};

const initialState: FoodMenuState = {
  [FOOD_MENU_KEY.FOOD_MENU]: [],
  [FOOD_MENU_KEY.FOOD_QC_KEYWORD]: [],
  [FOOD_MENU_KEY.IS_POS_ACTIONED]: false,
  [FOOD_MENU_KEY.TAGS_LIST]: []
};

export const foodMenuReducers = (state = initialState, action: FoodMenuActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case FOOD_MENU_ACTION_TYPE.SET_FOOD_MENU_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const foodMenuStateSelector = (key: FOOD_MENU_KEY) => (state: RootState) => state.food[key];
